import React, {
  MutableRefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import ExportIcon from "../../../../svg/Ads_Dashboard_Developement2/ExportIcon/elements.svg";
import DragAndDropIcon from "../../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import GraphIcon from "../../../../svg/Ads_Dashboard_Developement2/GraphIcon/elements.svg";
import {
  Button,
  CircularProgress,
  DialogContent,
  Drawer,
  Input,
  Option,
  Select,
  selectClasses,
  Switch,
} from "@mui/joy";
import { BASE_URL, BLACK, WHITE } from "../../../../appConstants";
import CondCmpForDbData from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/CondCmpForDbData";
import CondCmpForCreate from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/CondCmpForCreate";
import { useSelector } from "react-redux";
import axios from "axios";
import appError from "../../../../appError";
import toast from "react-hot-toast";
import {
  getFormattedValue,
} from "../../../../appFunctions";
import DrillThroughTable from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Drill Through Comparison Table/DrillThroughTable";
import ConditionCompCmp from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/ConditionCompCmp";
import CreateNewConditionModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/CreateNewConditionModal";
import ConfirmConditionModal from "../../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Condition Comparison Component/ConfirmConditionModal";

type DateProps = {
  startDate: Date;
  endDate: Date;
};
type Range = {
  rangeOne: DateProps;
  rangeTwo: DateProps;
};
type SearchObjProps = {
  value: string;
  frontend_value_type: string;
  backend_value_type: string;
};
type Matrice = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
  toggle: boolean;
  position: number;
};
type Parameter = {
  id: number;
  parameter_name: string;
  backend_parameter_name: string;
  toggle: boolean;
  position: number;
};
type Condition = {
  metric: string;
  parameter: string;
  // operator?: string;
  initial_value: string;
  dependent_value: string;
  Operation: string;
};
type MatricsProps = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
};
type ParametersProps = {
  id: number;
  parameter: string;
};
type OperationProps = {
  id: number;
  operation: string;
};
type NewConditionProps = {
  metric: string;
  metric_error?: boolean;
  parameter: string;
  parameter_error?: boolean;
  Operation: string;
  Operation_error?: boolean;
  initial_value: string;
  initial_value_error?: boolean;
  dependent_value: string;
};
type ListProps = {
  condition_name: string;
  condition_array: Condition[];
  condition_id: string;
  dashboard: string;
};
type SortProps = {
  metric: string;
  sort_by: string;
  direction: string;
};
type SearchObjArr = {
  detail_name: string;
  backend_name: string;
};
type SearchDataArrProps = {
  value: string;
};

type All_CategoriesProps = {
  principal_category: SearchDataArrProps[];
  main_category: SearchDataArrProps[];
  category: SearchDataArrProps[];
  sub_category: SearchDataArrProps[];
  product_name: SearchDataArrProps[];
  style_code: SearchDataArrProps[];
  model_code: SearchDataArrProps[];
  variant_code: SearchDataArrProps[];
  sku: SearchDataArrProps[];
  platform_code: SearchDataArrProps[];
  campaign_id: SearchDataArrProps[]; // _col1
  campaign_name: SearchDataArrProps[];
  adgroup_id: SearchDataArrProps[]; // _col1
  adgroup_name: SearchDataArrProps[];
  match_type: SearchDataArrProps[];
  searchterm: SearchDataArrProps[];
  [key: string]: SearchDataArrProps[]; // <-- Add this to allow indexing
};
type All_Sel_CategoriesProps = {
  principal_category: string[];
  main_category: string[];
  category: string[];
  sub_category: string[];
  product_name: string[];
  style_code: string[];
  model_code: string[];
  variant_code: string[];
  sku: string[];
  platform_code: string[];
  campaign_id: string[];
  campaign_name: string[];
  adgroup_id: string[];
  adgroup_name: string[];
  match_type: string[];
  searchterm: string[];
  [key: string]: string[]; // Allows dynamic indexing
};
type ColumnsHierarchyObj = {
  backend_name: string;
  frontend_name: string;
}
type ColumnsHierarchyMap = {
    [name: string]: ColumnsHierarchyObj[];
  };
type SelectedArr = {
    type: string;
    name: string;
  };
type PaginationProps = {
    limit: number;
    page: number;
  };
const Drill_Through_Page = () => {
  const [parametersData, setParametersData] = useState<Parameter[]>([]);

  const [matricesData, setMatricesData] = useState<Matrice[]>([
    {
      id: 1,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
      toggle: false,
      position: 0,
    },
    {
      id: 2,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
      toggle: false,
      position: 1,
    },
    {
      id: 3,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
      toggle: true,
      position: 2,
    },
    {
      id: 4,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
      toggle: true,
      position: 3,
    },
    {
      id: 5,
      matrice_name: "Ad Sales %",
      backend_matrice_name: "ad_sales_perc",
      toggle: false,
      position: 4,
    },
    {
      id: 6,
      matrice_name: "Gross Sales",
      backend_matrice_name: "gross_sales",
      toggle: true,
      position: 5,
    },
    {
      id: 7,
      matrice_name: "Organic Sales",
      backend_matrice_name: "organic_sales",
      toggle: true,
      position: 6,
    },
    {
      id: 8,
      matrice_name: "Organic Sales %",
      backend_matrice_name: "organic_sales_perc",
      toggle: false,
      position: 7,
    },
    {
      id: 9,
      matrice_name: "Ad Order",
      backend_matrice_name: "orders",
      toggle: false,
      position: 8,
    },
    {
      id: 10,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
      toggle: false,
      position: 9,
    },
    {
      id: 11,
      matrice_name: "Gross Unit",
      backend_matrice_name: "gross_units",
      toggle: false,
      position: 10,
    },
    {
      id: 12,
      matrice_name: "Organic Unit",
      backend_matrice_name: "organic_units",
      toggle: false,
      position: 11,
    },
    {
      id: 13,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
      toggle: true,
      position: 12,
    },
    {
      id: 14,
      matrice_name: "TACOS",
      backend_matrice_name: "tacos",
      toggle: true,
      position: 13,
    },
    {
      id: 15,
      matrice_name: "ROAS",
      backend_matrice_name: "roas",
      toggle: false,
      position: 14,
    },
    {
      id: 16,
      matrice_name: "TROAS",
      backend_matrice_name: "troas",
      toggle: false,
      position: 15,
    },
    {
      id: 17,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
      toggle: false,
      position: 16,
    },
    {
      id: 18,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
      toggle: false,
      position: 17,
    },
    {
      id: 19,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
      toggle: false,
      position: 18,
    },
    {
      id: 20,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
      toggle: false,
      position: 19,
    },
    {
      id: 21,
      matrice_name: "CAC",
      backend_matrice_name: "cac",
      toggle: false,
      position: 20,
    },
    {
      id: 22,
      matrice_name: "Glance View",
      backend_matrice_name: "gross_glanceviews",
      toggle: false,
      position: 21,
    },
  ]);

  // For Drawer
  const [parametersDataDrawer, setParametersDataDrawer] = useState<Parameter[]>([]);

  const [matricesDataDrawer, setMatricesDataDrawer] = useState<Matrice[]>([]);

  // Object for All Selected Categories
  const [sel_categories, setSel_Categories] = useState<All_Sel_CategoriesProps>(
    {
      //---------- Input
      principal_category: [],
      main_category: [],
      category: [],
      sub_category: [],
      product_name: [],
      style_code: [],
      model_code: [],
      variant_code: [],
      sku: [],
      platform_code: [],
      campaign_id: [],
      campaign_name: [],
      adgroup_id: [],
      adgroup_name: [],
      match_type: [],
      searchterm: []
    }
  );

  const [hierarchy_columns, setHierarchy_Columns] = useState<ColumnsHierarchyMap>({
        "4" : [{backend_name: "principal_category", frontend_name: "Principal Category"}, {backend_name:"main_category", frontend_name: "Main Category"}, {backend_name:"category", frontend_name: "Category"}, {backend_name:"sub_category", frontend_name: "Sub Category"}],
        "3" : [{backend_name:"main_category", frontend_name: "Main Category"}, {backend_name:"category", frontend_name: "Category"}, {backend_name:"sub_category", frontend_name: "Sub Category"}],
        "2" : [{backend_name:"category", frontend_name: "Category"}, {backend_name:"sub_category", frontend_name: "Sub Category"}]
    });

  const [cols_hierarchy_map, setCols_Hierarchy_map] = useState<ColumnsHierarchyMap>({
    "journey_1" : [{backend_name:"product_name", frontend_name: "Product Name"}, {backend_name:"style_code", frontend_name: 'Style Code'},{backend_name:"model_code", frontend_name: "Model Code"}, {backend_name:"variant_code", frontend_name: "Variant Code"}, {backend_name:"sku", frontend_name: "SKU ID"}, {backend_name:"platform_code", frontend_name: "Platform Code"},{backend_name:"campaign_id", frontend_name: "Campaign Name"},{backend_name: "adgroup_id", frontend_name: "Ad Group Name"}, {backend_name: "targeting_and_match_type", frontend_name: "Targeting & Match Type"},{backend_name: "searchterm", frontend_name: "Customer Search Term"}],

    "journey_2" : [{backend_name:"product_name", frontend_name: "Product Name"},{backend_name:"style_code", frontend_name: 'Style Code'},{backend_name:"model_code", frontend_name: "Model Code"}, {backend_name:"variant_code", frontend_name: "Variant Code"}, {backend_name:"sku", frontend_name: "SKU ID"}, {backend_name:"platform_code", frontend_name: "Platform Code"}, {backend_name:"campaign_id", frontend_name: "Campaign Name"}, {backend_name: "placementclassification", frontend_name: "Placement"}],

    "journey_3" : [{backend_name:"product_name", frontend_name: "Product Name"}, {backend_name:"campaign_id", frontend_name: "Campaign Name"},{backend_name: "adgroup_id", frontend_name: "Ad Group Name"}, {backend_name: "targeting_and_match_type", frontend_name: "Targeting & Match Type"},{backend_name: "searchterm", frontend_name: "Customer Search Term"}],

    "journey_4" : [{backend_name:"product_name", frontend_name: "Product Name"}, {backend_name:"campaign_id", frontend_name: "Campaign Name"}, {backend_name: "placementclassification", frontend_name: "Placement"}],
  });

  // hierachy for Product Details column 
  const [cols_hierarchy, setCols_hierarchy] = useState<ColumnsHierarchyObj[]>([]);
  const [selPreviousArr, setSelPreviousArr] = useState<SelectedArr[]>([]); 
  const [selectedarr, setSelectedArr] = useState<SelectedArr[]>([]); 

  const onDrillUpHandler = () => {
    if(selPreviousArr?.length < selectedarr?.length ){
      let new_search_obj = {
        value: "",
        frontend_value_type: cols_hierarchy?.find((item : ColumnsHierarchyObj) => item?.backend_name === selectedarr[selectedarr?.length - 1]?.type)?.frontend_name ?? "",
        backend_value_type: cols_hierarchy?.find((item : ColumnsHierarchyObj) => item?.backend_name === selectedarr[selectedarr?.length - 1]?.type)?.backend_name ?? "",
      }
      setSearchBackendObj(new_search_obj);
      setSearchObj(new_search_obj);
      setSelectedArr((prev) => {
        let new_selected_arr = prev?.slice(0, -1);
        setSel_Categories((prev) => {
          let new_sel_categories = {} as All_Sel_CategoriesProps;
          new_selected_arr?.map((item : SelectedArr) =>{
            new_sel_categories[item?.type] = [item?.name]
          });
          return new_sel_categories;
        });
        return new_selected_arr;
      });
    }
  };

  const onDrillDownHandler = () => {
  };

  const { brand_id, data_query } = useParams();
  const { platform_id } = useSelector((state: any) => state.appData);

  // Get today's date and week range
  const today = new Date();

  const [InputRange, setInputRange] = useState<Range>({
    // ------- Input
    rangeOne: {
      // Current Date
      startDate: today,
      endDate: today,
    },
    rangeTwo: {
      // Comparison Date
      startDate: today,
      endDate: today,
    },
  });

  const [valueFilter, setValueFilter] = useState<string>("VALUE"); // -------- Input   // Value OR Share % OR AVERAGE
  const [searchobj, setSearchObj] = useState<SearchObjProps>({
    // -------- Input
    value: "",
    frontend_value_type: "",
    backend_value_type: "",
  });

  const [conditionsArr, setConditionsArr] = useState<Condition[]>([]); //---------- Input
  const [createNewCond, setCreateNewCond] = useState<boolean>(false);

  const [sort, setSort] = useState<SortProps>({
    // ------ Input
    metric: "",
    sort_by: "current",
    direction: "",
  });

  const [loading, setLoading] = useState<boolean>(false); // Loader for Table

  // hierarchy for matrices
  const [matrices_hierarchy, setMatrices_hierarchy] = useState<string[]>([
    "impressions",
    "clicks",
    "spend",
    "sales",
    "ad_sales_perc",
    "gross_sales",
    "organic_sales",
    "organic_sales_perc",
    "orders",
    "units",
    "gross_units",
    "organic_units",
    "acos",
    "tacos",
    "roas",
    "troas",
    "ctr",
    "cvr",
    "cpc",
    "aov",
    "cac",
    "gross_glanceviews",
  ]);

  // hierarchy for parameters
  const [parameters_hierarchy, setParameters_hierarchy] = useState<string[]>(
    []
  );

  const [pagination, setPagination] = useState<PaginationProps>({
      limit: 50,
      page: 1,
    });

  const [positive_values, setPositive_Values] = useState([
    "impressions",
    "clicks",
    "sales",
    "gross_sales",
    "organic_sales",
    "organic_units",
    "orders",
    "units",
    "gross_units",
    "roi",
    "troi",
    "ctr",
    "cvr",
    "aov",
    "roas",
    "troas",
    "gross_glanceviews",
    "ad_sales_perc",
    "organic_sales_perc"
  ]);

  const [negative_values, setNegative_Values] = useState([
    "spend",
    "acos",
    "tacos",
    "cpc",
    "cac",
  ]);

  const [Total_data, setTotal_data] = useState<any[]>([]); // Atlast assign empty array
  const [sel_parameters, setSel_Parameters] = useState<string[]>([]);
  const [exportToggle, setExportToggle] = useState<boolean>(false);

  const [dropDownRawData, setDropDownRawData] = useState<any[]>([]);
  const [dropDownformatedData, setDropDownformatedData] = useState<All_CategoriesProps>({} as All_CategoriesProps); 

  // For Storing Data after changing SearchObj frontend and backend value
  const [searchDataArr, setSearchDataArr] = useState<SearchDataArrProps[]>([]);

  // useEffect(() => {
  //   if (brand_id && dropDownRawData?.length > 0) {
  //     setSearchDataArr(dropDownformatedData[searchobj?.backend_value_type]);
  //   }
  // }, [searchobj?.backend_value_type]);

  const [sortByToggle, setSortByToggle] = useState<boolean>(false);
  const [sortValues, setSortValues] = useState<string[]>([
    "current",
    "previous",
    "difference",
    "difference_percentage",
  ]);

  const [searchobjToggle, setSearchobjToggle] = useState<boolean>(false);
  const [drawerToggle, setDrawerToggle] = useState<boolean>(false);
  const [drawerSubOption, setDrawerSubOption] = useState<string>("");
  const [conditionToggle, setConditionToggle] = useState<boolean>(false);

  const [matricsArr, setMatricsArr] = useState<MatricsProps[]>([
    {
      id: 1,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
    },
    {
      id: 2,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
    },
    {
      id: 3,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
    },
    {
      id: 4,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
    },
    {
      id: 5,
      matrice_name: "Ad Sales %",
      backend_matrice_name: "ad_sales_perc",
    },
    {
      id: 6,
      matrice_name: "Gross Sales",
      backend_matrice_name: "gross_sales",
    },
    {
      id: 7,
      matrice_name: "Organic Sales",
      backend_matrice_name: "organic_sales",
    },
    {
      id: 8,
      matrice_name: "Organic Sales %",
      backend_matrice_name: "organic_sales_perc",
    },
    {
      id: 9,
      matrice_name: "Ad Order",
      backend_matrice_name: "orders",
    },
    {
      id: 10,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
    },
    {
      id: 11,
      matrice_name: "Gross Unit",
      backend_matrice_name: "gross_units",
    },
    {
      id: 12,
      matrice_name: "Organic Unit",
      backend_matrice_name: "organic_units",
    },
    {
      id: 13,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
    },
    {
      id: 14,
      matrice_name: "TACOS",
      backend_matrice_name: "tacos",
    },
    {
      id: 15,
      matrice_name: "ROAS",
      backend_matrice_name: "roas",
    },
    {
      id: 16,
      matrice_name: "TROAS",
      backend_matrice_name: "troas",
    },
    {
      id: 17,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
    },
    {
      id: 18,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
    },
    {
      id: 19,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
    },
    {
      id: 20,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
    },
    {
      id: 21,
      matrice_name: "CAC",
      backend_matrice_name: "cac",
    },
    {
      id: 22,
      matrice_name: "Glance View",
      backend_matrice_name: "gross_glanceviews",
    },
  ]);

  const [parameterArr, setParamterArr] = useState<ParametersProps[]>([
    {
      id: 1,
      parameter: "current",
    },
    {
      id: 2,
      parameter: "previous",
    },
    {
      id: 3,
      parameter: "difference",
    },
    {
      id: 4,
      parameter: "difference_percentage",
    },
  ]);

  const [operationsArr, setOperationsArr] = useState<OperationProps[]>([
    {
      id: 1,
      operation: "<",
    },
    {
      id: 2,
      operation: "=",
    },
    {
      id: 3,
      operation: ">",
    },
    {
      id: 4,
      operation: "Between",
    },
  ]);

  const [localconditions, setLocalConditions] = useState<Condition[]>([]); // Array for All Conditons Box
  const [local_Cond_name, setlocal_Cond_name] = useState<string>("");
  const [newconditionsArr, setNewConditionsArr] = useState<NewConditionProps[]>(
    local_Cond_name
      ? []
      : [
          {
            metric: "",
            parameter: "",
            Operation: "",
            initial_value: "",
            dependent_value: "",
          },
        ]
  );
  const [newcondition, setNewCondition] = useState<Condition>({
    metric: "",
    parameter: "",
    Operation: "",
    initial_value: "",
    dependent_value: "",
  });

  const [saveConditionToggle, setSaveConditionToggle] =
    useState<boolean>(false);
  const [listarr, setListArr] = useState<ListProps[]>([]);
  const [temp_list_name, setTemp_List_name] = useState<string>("");
  const [local_Cond_id, setlocal_Cond_id] = useState<string>("");
  const [confirmConditionToggle, setConfirmConditionToggle] =
    useState<boolean>(false);
  const [conditonsSave, setConditionsSave] = useState<boolean>(false);

  const createConditionLists = async () => {
    let temp_arr2 = [
      ...localconditions,
      ...newconditionsArr.filter(
        (cond) =>
          cond?.metric !== "" &&
          cond?.parameter !== "" &&
          cond?.Operation !== "" &&
          cond?.initial_value !== ""
      ),
    ];
    const cleaned_arr = temp_arr2.map((obj) =>
      Object.fromEntries(
        Object.entries(obj).filter(([key]) => !key.endsWith("_error"))
      )
    );
    try {
      setConditionsSave(true);
      const temp_condition_obj = {
        dashboard: "DRILL_THROUGH_COMPARISON",
        condition_name: temp_list_name,
        condition_array: cleaned_arr,
      };
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${BASE_URL}settings/dashboardSettings/conditions?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_condition_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(res?.data?.data?.message);
      fetchConditionsData();
      setSaveConditionToggle(false);
      setNewConditionsArr([
        {
          metric: "",
          parameter: "",
          Operation: "",
          initial_value: "",
          dependent_value: "",
        },
      ]);
      setLocalConditions([]);
      setTemp_List_name("");
    } catch (error) {
      appError(error);
    } finally{
      setConditionsSave(false);
    }
  };

  let menuRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let menuButtonRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let FilterRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let FilterButtonRef = useRef<HTMLImageElement | null>(null); // Menu button reference

  const handleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node) &&
      menuButtonRef.current &&
      !menuButtonRef.current.contains(event.target as Node)
    ) {
      setSortByToggle(false); // Close the dropdown if clicked outside
    }
  };

  const FilterhandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      FilterRef.current &&
      !FilterRef.current.contains(event.target as Node) &&
      FilterButtonRef.current &&
      !FilterButtonRef.current.contains(event.target as Node)
    ) {
      setSearchobjToggle(false); // Close the dropdown if clicked outside
    }
  };

  // Add event listener to detect clicks outside
  useEffect(() => {
    // Attach the click event listener to the document
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("click", FilterhandleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("click", FilterhandleClickOutside);
    };
  }, []);

  const ClearAll = () => {
    setLocalConditions([]);
    setlocal_Cond_name("");
    setNewConditionsArr([
      {
        metric: "",
        parameter: "",
        Operation: "",
        initial_value: "",
        dependent_value: "",
      },
    ]);
  };

  // For Parameter
  const ParameterSwitchChangeHandler = (parameter_id: Number) => {
    const Exist = parametersDataDrawer.find(
      (d: Parameter) => d?.id === parameter_id
    )?.toggle;
    let newParameterArr = [] as Parameter[];
    if (Exist) {
      if (parametersDataDrawer.filter((item) => item.toggle).length === 1) {
        toast.error("Minimum 1 Parameter to be present");
        return;
      } else if (parametersDataDrawer.filter((item) => item.toggle).length > 1) {
        newParameterArr = parametersDataDrawer.map((d) =>
          d.id === parameter_id ? { ...d, toggle: false } : d
        );
      }
    } else {
      newParameterArr = parametersDataDrawer.map((d) =>
        d.id === parameter_id ? { ...d, toggle: true } : d
      );
    }
    setParametersDataDrawer(newParameterArr);
    // updateColumns([], "PARAMETER", newParameterArr, [], true);
  };

  // For Metricess
  const MatriceSwitchChangeHandler = (matrice_id: Number) => {
    const Exist = matricesDataDrawer.find(
      (d: Matrice) => d?.id === matrice_id
    )?.toggle;
    let newMatricesArr = [] as Matrice[];
    if (Exist) {
      if (matricesDataDrawer.filter((item) => item.toggle).length === 1) {
        toast.error("Minimum 1 Matrice to be present");
        return;
      } else if (matricesDataDrawer.filter((item) => item.toggle).length > 1) {
        newMatricesArr = matricesDataDrawer.map((d) =>
          d.id === matrice_id ? { ...d, toggle: false } : d
        );
      }
    } else {
      newMatricesArr = matricesDataDrawer.map((d) =>
        d.id === matrice_id ? { ...d, toggle: true } : d
      );
    }
    setMatricesDataDrawer(newMatricesArr);
    // updateColumns([], "METRICE", [], newMatricesArr, true);
  };

  // Drag & Drop Functionality
  // For Parameter
  const [draggedParameter, setDraggedParameter] = useState<Parameter | null>(
    null
  );

  const parameterDragStarthandle = (item: Parameter) => {
    setDraggedParameter(item);
  };

  const parameterDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const parameterhandleDrop = (targetItem: Parameter) => {
    if (!draggedParameter || draggedParameter.id === targetItem.id) return;
  
    const draggedIndex = parametersDataDrawer.findIndex(
      (item) => item?.id === draggedParameter.id
    );
    const targetIndex = parametersDataDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...parametersDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
    setParametersDataDrawer(reorderedMatricesData);
  };

  // For Metrice
  const [draggedMetrice, setDraggedMetrice] = useState<Matrice | null>(null);

  const metriceDragStarthandle = (item: Matrice) => {
    setDraggedMetrice(item);
  };

  const metriceDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const metricehandleDrop = (targetItem: Matrice) => {
    if (!draggedMetrice || draggedMetrice.id === targetItem.id) return;
  
    const draggedIndex = matricesDataDrawer.findIndex(
      (item) => item?.id === draggedMetrice.id
    );
    const targetIndex = matricesDataDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...matricesDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
    setMatricesDataDrawer(reorderedMatricesData);
  };

  const [searchFocus, setSearchFocus] = useState<boolean>(false);
  const [searchFileArray, setSearchFileArray] = useState<SearchDataArrProps[]>(
    []
  );

  const handleSearch = (event: any) => {
    const searchValue = event.target.value;
    setSearchObj((prev) => ({
      ...prev,
      value: searchValue,
    }));

    // Filter the data based on input
    const filteredResults = searchDataArr?.filter((item) =>
        item.value?.toString().toLowerCase().includes(searchValue.toLowerCase())
      )
      .slice(0, 10);
    if (searchValue === "") {
      setSearchBackendObj({
        value: "",
        frontend_value_type: "",
        backend_value_type: ""
      });

    }
    setSearchFileArray(filteredResults);
  };

  const onSearchvalueInputChange = (e: any) => {
    if (e.target.value?.trimStart()) {
      setSearchFocus(true);
      setSearchobjToggle(false);
    } else {
      setSearchFocus(false);
    }
    handleSearch(e);
  };

  const [resetToggle, setResetToggle] = useState<boolean>(false);

  const onResetColumnsHandler = () => {
      setParametersDataDrawer((prev) => {
        const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
        
        // Update the position field in numerical order
        const updatedMatrices = sortedMatrices.map((item, index) => ({
          ...item,
          position: index, // Assign position based on the index in the sorted array
        }));
        
        return updatedMatrices;
      });

      setMatricesDataDrawer((prev) => {
        const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
        
        // Update the position field in numerical order
        const updatedMatrices = sortedMatrices.map((item, index) => ({
          ...item,
          position: index, // Assign position based on the index in the sorted array
        }));
        
        return updatedMatrices;
      });
        
  };

  // GET API for All Saved Conditions from Backend
  const fetchConditionsData = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}settings/dashboardSettings/conditions?brand_id=${brand_id}&platform_id=${platform_id}&dashboard=DRILL_THROUGH_COMPARISON`;
      const result = await axios.get(api, { headers });
      const { data } = result?.data;
      setListArr(data);
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const [journey, setJourney] = useState<string>("");

  const getDataFromUrlPath = () => {
    if (data_query) {
      setLoading(true);
        const cleaned = decodeURIComponent(data_query).replace(/^:/, '');
        try {
          const parsedData = JSON.parse(cleaned);

          let new_cols_hierarchy = [ ...hierarchy_columns[String(parsedData?.hierarchy_levels)], ...cols_hierarchy_map[parsedData?.journey_name]];
          setJourney(parsedData?.journey_name);
          setCols_hierarchy(new_cols_hierarchy);
          setSelPreviousArr(parsedData?.arr);
          setSelectedArr(parsedData?.arr);
          let inputRange = {
            rangeOne : {
              startDate: new Date(parsedData?.dateRange?.rangeOne?.startDate),
              endDate: new Date(parsedData?.dateRange?.rangeOne?.endDate),
            },
            rangeTwo : {
              startDate : new Date(parsedData?.dateRange?.rangeTwo?.startDate),
              endDate: new Date(parsedData?.dateRange?.rangeTwo?.endDate),
            }
          };
          setInputRange(inputRange);
          let new_sel_categories = {} as All_Sel_CategoriesProps;
          parsedData?.arr?.map((item : SelectedArr) =>{
            new_sel_categories[item?.type] = [item?.name]
          });

          setSel_Categories(new_sel_categories);

          setSearchObj((prev) => {
            let col_detail = new_cols_hierarchy[new_cols_hierarchy?.findIndex(item => parsedData?.arr[parsedData?.arr?.length - 1]?.type === item?.backend_name) + 1];
      
            return {
              ...prev,
              frontend_value_type: col_detail?.frontend_name,
              backend_value_type: col_detail?.backend_name
            };
          });
          parsedData?.arr?.map((item: SelectedArr) => {
            fetchCurrentCatData(new_sel_categories, new_cols_hierarchy, inputRange, item?.name, item?.type, parsedData?.arr);
          })
        } catch (e) {
          console.error('Failed to parse JSON:', e);
        } 
        finally {
          setLoading(false);
        }
      }
  }

  const getParametersAndMetrics = () => {
    let new_parameters_arr = [
      {
        id: 1,
        parameter_name: "Current Period",
        backend_parameter_name: "current",
        toggle: true,
        position: 0,
      },
      {
        id: 2,
        parameter_name: "Comparison Period",
        backend_parameter_name: "previous",
        toggle: false,
        position: 1,
      },
      {
        id: 3,
        parameter_name: "Difference",
        backend_parameter_name: "difference",
        toggle: false,
        position: 2,
      },
      {
        id: 4,
        parameter_name: "Difference %",
        backend_parameter_name: "difference_percentage",
        toggle: false,
        position: 3,
      },
    ];
    setParametersData([...new_parameters_arr]);
    setParametersDataDrawer([...new_parameters_arr]);
    setParameters_hierarchy([
      "current",
      "previous",
      "difference",
      "difference_percentage",
    ]);
    setSel_Parameters([
      "current",
    ]);

    let new_matrics_arr = [
      {
        id: 1,
        matrice_name: "Impressions",
        backend_matrice_name: "impressions",
        toggle: false,
        position: 0,
      },
      {
        id: 2,
        matrice_name: "Clicks",
        backend_matrice_name: "clicks",
        toggle: false,
        position: 1,
      },
      {
        id: 3,
        matrice_name: "Spend",
        backend_matrice_name: "spend",
        toggle: true,
        position: 2,
      },
      {
        id: 4,
        matrice_name: "Ad Sales",
        backend_matrice_name: "sales",
        toggle: true,
        position: 3,
      },
      {
        id: 5,
        matrice_name: "Ad Sales %",
        backend_matrice_name: "ad_sales_perc",
        toggle: false,
        position: 4,
      },
      {
        id: 6,
        matrice_name: "Gross Sales",
        backend_matrice_name: "gross_sales",
        toggle: true,
        position: 5,
      },
      {
        id: 7,
        matrice_name: "Organic Sales",
        backend_matrice_name: "organic_sales",
        toggle: true,
        position: 6,
      },
      {
        id: 8,
        matrice_name: "Organic Sales %",
        backend_matrice_name: "organic_sales_perc",
        toggle: false,
        position: 7,
      },
      {
        id: 9,
        matrice_name: "Ad Order",
        backend_matrice_name: "orders",
        toggle: false,
        position: 8,
      },
      {
        id: 10,
        matrice_name: "Ad Units",
        backend_matrice_name: "units",
        toggle: false,
        position: 9,
      },
      {
        id: 11,
        matrice_name: "Gross Unit",
        backend_matrice_name: "gross_units",
        toggle: false,
        position: 10,
      },
      {
        id: 12,
        matrice_name: "Organic Unit",
        backend_matrice_name: "organic_units",
        toggle: false,
        position: 11,
      },
      {
        id: 13,
        matrice_name: "ACOS",
        backend_matrice_name: "acos",
        toggle: true,
        position: 12,
      },
      {
        id: 14,
        matrice_name: "TACOS",
        backend_matrice_name: "tacos",
        toggle: true,
        position: 13,
      },
      {
        id: 15,
        matrice_name: "ROAS",
        backend_matrice_name: "roas",
        toggle: false,
        position: 14,
      },
      {
        id: 16,
        matrice_name: "TROAS",
        backend_matrice_name: "troas",
        toggle: false,
        position: 15,
      },
      {
        id: 17,
        matrice_name: "CTR",
        backend_matrice_name: "ctr",
        toggle: false,
        position: 16,
      },
      {
        id: 18,
        matrice_name: "CVR",
        backend_matrice_name: "cvr",
        toggle: false,
        position: 17,
      },
      {
        id: 19,
        matrice_name: "CPC",
        backend_matrice_name: "cpc",
        toggle: false,
        position: 18,
      },
      {
        id: 20,
        matrice_name: "AOV",
        backend_matrice_name: "aov",
        toggle: false,
        position: 19,
      },
      {
        id: 21,
        matrice_name: "CAC",
        backend_matrice_name: "cac",
        toggle: false,
        position: 20,
      },
      {
        id: 22,
        matrice_name: "Glance View",
        backend_matrice_name: "gross_glanceviews",
        toggle: false,
        position: 21,
      },
    ];
    // setMatricesData(new_matrics_arr);
    setMatricesDataDrawer(new_matrics_arr);
    // setMatrices_hierarchy([
    //   "impressions",
    //   "clicks",
    //   "spend",
    //   "sales",
    //   "ad_sales_perc",
    //   "gross_sales",
    //   "organic_sales",
    //   "organic_sales_perc",
    //   "orders",
    //   "units",
    //   "gross_units",
    //   "organic_units",
    //   "acos",
    //   "tacos",
    //   "roas",
    //   "troas",
    //   "ctr",
    //   "cvr",
    //   "cpc",
    //   "aov",
    //   "cac",
    //   "gross_glanceviews",
    // ]);
  }

  useEffect(() => {
    if (brand_id && platform_id && data_query) {
        getDataFromUrlPath();
        fetchConditionsData();
        getParametersAndMetrics();
    }
  }, [brand_id, platform_id, data_query]);

  const [resultData, setResultData] = useState<any[]>([]);

  const transformToObject = (data : any, columnsArr: string[], ip_column: string) => {
    const result: any = [];
    data?.map((obj : any) => {
      let new_obj = {};
      const singleRow : any = {};
              columnsArr.forEach((metric) => {
                  singleRow[metric] = {
                    current: obj[`${metric}_current`] !== null ? getFormattedValue(obj[`${metric}_current`]) : "0",
                    previous: obj[`${metric}_previous`] !== null ? getFormattedValue(obj[`${metric}_previous`]) : "0",
                    difference: obj[`${metric}_difference`] !== null ? getFormattedValue(obj[`${metric}_difference`]) : "0",
                    difference_percentage: obj[`${metric}_difference_percentage`] !== null ? getFormattedValue(obj[`${metric}_difference_percentage`]) : "0",
                  };
              });
      for (let key in obj){
        if(cols_hierarchy?.some(item => item?.backend_name === key)){
          if(ip_column === "campaign_id"){
            new_obj = {type : ip_column, id : obj[ip_column] , name: obj["campaign_name"], row: [singleRow], children: []}
          }
          else if(ip_column === "adgroup_id"){
            new_obj = {type : ip_column, id : obj[ip_column] , name: obj["adgroup_name"], row: [singleRow], children: []}
          } else{
            new_obj = {type : key, name: obj[key], row: [singleRow], children: []}
          }
        }
      }

      result?.push(new_obj);
    });
    return result;
  }

  // Run Only Once when page loads
  const transformToObjectOnce = (data : any, columnsArr: string[], ip_column: string, ip_cols_hierarchy: ColumnsHierarchyObj[]) => {
    const result: any = [];
    data?.map((obj : any) => {
      let new_obj = {};
      const singleRow : any = {};
              columnsArr.forEach((metric) => {
                  singleRow[metric] = {
                    current: obj[`${metric}_current`] !== null ? getFormattedValue(obj[`${metric}_current`]) : "0",
                    previous: obj[`${metric}_previous`] !== null ? getFormattedValue(obj[`${metric}_previous`]) : "0",
                    difference: obj[`${metric}_difference`] !== null ? getFormattedValue(obj[`${metric}_difference`]) : "0",
                    difference_percentage: obj[`${metric}_difference_percentage`] !== null ? getFormattedValue(obj[`${metric}_difference_percentage`]) : "0",
                  };
              });
      for (let key in obj){
        if(ip_cols_hierarchy?.some(item => item?.backend_name === key)){
          if(ip_column === "campaign_id"){
            new_obj = {type : ip_column, id : obj[ip_column] , name: obj["campaign_name"], row: [singleRow], children: []}
          }
          else if(ip_column === "adgroup_id"){
            new_obj = {type : ip_column, id : obj[ip_column] , name: obj["adgroup_name"], row: [singleRow], children: []}
          } else{
            new_obj = {type : key, name: obj[key], row: [singleRow], children: []}
          }
        }
      }

      result?.push(new_obj);
    });
    return result;
  }
  const [rows, setRows] = useState<number>(0);
  // Below Function for getting all Children data of category on which we have clicked in Analysis Page
  const fetchCurrentCatSubData = async (ip_InputRange: Range, ip_sel_categories: All_Sel_CategoriesProps, ip_selectedarr: SelectedArr[], arr: any[], ip_cols_hierarchy: ColumnsHierarchyObj[], name : string, ip_type : string) => {
    
    let col_name = ip_cols_hierarchy[
      ip_cols_hierarchy?.findIndex(item => item?.backend_name === ip_type) + 1
    ]?.backend_name;

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${ip_InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            ip_InputRange?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${ip_InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            ip_InputRange?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${ip_InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            ip_InputRange?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${ip_InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            ip_InputRange?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: Object.fromEntries(
          Object.entries(ip_sel_categories).filter(
            ([_, value]) => value.length > 0
          )
        ),
      },
      conditions: [],
      sort: { metric: "",
        sort_by: "",
        direction: "",
      },
      product_detail_column: ip_cols_hierarchy[ip_cols_hierarchy?.findIndex((item) => ip_selectedarr[ip_selectedarr?.length - 1]?.type === item?.backend_name) + 1]?.backend_name === "campaign_id" ? ["campaign_id", "campaign_name"] : ip_cols_hierarchy[ip_cols_hierarchy?.findIndex((item) => ip_selectedarr[ip_selectedarr?.length - 1].type === item?.backend_name) + 1]?.backend_name === "adgroup_id" ? ["adgroup_id", "adgroup_name"] : [ip_cols_hierarchy[ip_cols_hierarchy?.findIndex((item) => ip_selectedarr[ip_selectedarr?.length - 1].type === item?.backend_name) + 1]?.backend_name],
      metrics_column: matricesData?.map(item => item?.backend_matrice_name),
    };
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/drillThrough/getComparasionOfTwoRange?brand_id=${brand_id}&page=${pagination?.page}&limit=${pagination?.limit}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) { 

      } else if (results?.length > 0) {
        let search_arr = [] as SearchDataArrProps[];
        if(col_name === "campaign_id"){
          search_arr = results?.map((item : any) => ({value: `${item?.campaign_name}`}));
          setDropDownformatedData((prev) => ({...prev, ["campaign_name"] : search_arr}))

        } 
        else if(col_name === "adgroup_id"){
          search_arr = results?.map((item : any) => ({value: `${item?.adgroup_name}`}));
          setDropDownformatedData((prev) => ({...prev, ["adgroup_name"] : search_arr}))
        } 
        else {
          search_arr = results?.map((item : any) => ({value: `${item?.[col_name]}`}));
          setDropDownformatedData((prev) => ({...prev, [col_name] : search_arr}))
        }
        setSearchFileArray(search_arr);
        setSearchDataArr(search_arr);
        setResultData((prev) => {
          let new_arr = [{
            ...arr[0],
            children: [...transformToObjectOnce(results, matricesData?.map(item => item?.backend_matrice_name), ip_cols_hierarchy[
              ip_cols_hierarchy?.findIndex(item => item?.backend_name === ip_type) + 1
            ]?.backend_name, ip_cols_hierarchy) ]
          }];

          let new_data_arr = [...prev, ...new_arr];

          // Sort new_data_arr based on ip_cols_hierarchy
          let sorted_data_arr = new_data_arr?.sort((a, b) => {
              const aIndex = ip_cols_hierarchy?.findIndex(item => item?.backend_name === a.type);
              const bIndex = ip_cols_hierarchy?.findIndex(item => item?.backend_name === b.type);
          
              if (aIndex !== bIndex) return aIndex - bIndex;
               // Handle undefined names safely
              const aName = a?.name ?? '';
              const bName = b?.name ?? '';
              return aName.localeCompare(bName);
              // return a.name.localeCompare(b.name);
          });
          return sorted_data_arr;
        });
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  }

  // Below Function for Getting all Categories initially once
  const fetchCurrentCatData = async (ip_sel_categories: All_Sel_CategoriesProps, ip_cols_hierarchy: ColumnsHierarchyObj[], ip_InputRange: Range,ip_name: string, ip_type : string, ip_selectedarr: SelectedArr[]) => {

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${ip_InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            ip_InputRange?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${ip_InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            ip_InputRange?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${ip_InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            ip_InputRange?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${ip_InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            ip_InputRange?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_InputRange?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter : Object.fromEntries(
          Object.entries(ip_sel_categories).filter(
            ([_, value]) => value.length > 0
          )
        ),
      },
      conditions: [],
      sort: { metric: "",
        sort_by: "",
        direction: "",
      },
      product_detail_column: [ip_type],
      metrics_column: matricesData?.map(item => item?.backend_matrice_name),
    };
    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/drillThrough/getComparasionOfTwoRange?brand_id=${brand_id}&page=${pagination?.page}&limit=${pagination?.limit}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) { 
   
      } else if (results.length > 0) {
        if(ip_selectedarr?.slice(0,-1)?.some(item => item?.name === ip_name && item?.type === ip_type)){
          setResultData((prev : any) =>{
            let new_data_arr = [...prev, transformToObjectOnce(results, matricesData?.map(item => item?.backend_matrice_name), ip_type, ip_cols_hierarchy)[0]];
            let sorted_data_arr = new_data_arr?.sort((a, b) => {
                const aIndex = ip_cols_hierarchy.findIndex(item => item?.backend_name === a.type);
                const bIndex = ip_cols_hierarchy.findIndex(item => item?.backend_name === b.type);
                // indexOf(b.type);
            
                if (aIndex !== bIndex) return aIndex - bIndex;
                const aName = a?.name || '';
                const bName = b?.name || '';
                return aName.localeCompare(bName);
            });
            return sorted_data_arr;
          });
          setRows(prev => prev + 1);
        }
        else {
          let new_arr = [...transformToObjectOnce(results, matricesData?.map(item => item?.backend_matrice_name), ip_type, ip_cols_hierarchy)];
          fetchCurrentCatSubData(ip_InputRange,ip_sel_categories, ip_selectedarr, new_arr, ip_cols_hierarchy, ip_name, ip_type);
        }
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false)
    }
  }

 
  // Use Below function for all Filters & Conditions & drill down
  const fetchonClick = async(data: any, sel_categories: All_Sel_CategoriesProps, selectedcatarr: SelectedArr[], ip_sort: SortProps) => {

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: Object.fromEntries(
          Object.entries(sel_categories).filter(
            ([_, value]) => value.length > 0
          )
        ),
      },
      conditions: conditionsArr.map((singleCondition) => ({
        metric: singleCondition?.metric,
        parameter: singleCondition?.parameter,
        operator: singleCondition?.Operation.toUpperCase(),
        initial_value: Number(singleCondition?.initial_value),
        dependent_value: Number(singleCondition?.dependent_value),
      })),
      sort: ip_sort,
      product_detail_column: cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedcatarr[selectedcatarr?.length - 1].type === item?.backend_name) + 1]?.backend_name === "campaign_id" ? ["campaign_id", "campaign_name"] : cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedcatarr[selectedcatarr?.length - 1].type === item?.backend_name) + 1]?.backend_name === "adgroup_id" ? ["adgroup_id", "adgroup_name"] : [cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedcatarr[selectedcatarr?.length - 1].type === item?.backend_name) + 1]?.backend_name],
      metrics_column: matricesData?.map(item => item?.backend_matrice_name),
    };
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/drillThrough/getComparasionOfTwoRange?brand_id=${brand_id}&page=${pagination?.page}&limit=${pagination?.limit}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) { 
      
      } else if (results.length > 0) {
       
        let col_name = cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedcatarr[selectedcatarr?.length - 1].type === item?.backend_name) + 1]?.backend_name;
        let search_arr = [] as SearchDataArrProps[];
        if(col_name === "campaign_id"){
          search_arr = results?.map((item : any) => ({value: `${item?.campaign_name}`}));
          setDropDownformatedData((prev) => ({...prev, ["campaign_name"] : search_arr}));
        } 
        else if(col_name === "adgroup_id"){
          search_arr = results?.map((item : any) => ({value: `${item?.adgroup_name}`}));
          setDropDownformatedData((prev) => ({...prev, ["adgroup_name"] : search_arr}));
        } 
        else {
          search_arr = results?.map((item : any) => ({value: `${item?.[col_name]}`}));
          setDropDownformatedData((prev) => ({...prev, [col_name] : search_arr}));
        }
        setSearchFileArray(search_arr);
        setSearchDataArr(search_arr);
        setResultData((prev) => {
          let new_arr_obj = prev.find(item => item?.children?.length > 0);  // Clone the first item to avoid mutation
          let count = prev?.findIndex(item => item?.children?.length > 0) + 1;
          let new_obj;
          
          if(journey === "journey_3" || journey === "journey_4"){
            while(new_arr_obj?.type !== selectedcatarr[selectedcatarr?.length - 1]?.type || new_arr_obj?.name != selectedcatarr[selectedcatarr?.length - 1]?.name){
              
              if(new_arr_obj?.type === "product_name" || new_arr_obj?.type === "campaign_id"){
                new_obj = new_arr_obj?.children?.find((item : any) => item?.type === selectedcatarr[count]?.type && item?.id == selectedcatarr[count]?.name);
              } else if(new_arr_obj?.type !== "product_name" || new_arr_obj?.type !== "campaign_id") {
                new_obj = new_arr_obj?.children?.find((item : any) => item?.type === selectedcatarr[count]?.type && item?.name == selectedcatarr[count]?.name);
              }

              if(!new_obj){
                break;
              }

              count++;
              new_arr_obj = new_obj;
            }
          }
          else if(journey === "journey_2"){

            while(new_arr_obj?.type !== selectedcatarr[selectedcatarr?.length - 1]?.type || new_arr_obj?.name != selectedcatarr[selectedcatarr?.length - 1]?.name || new_arr_obj?.id != selectedcatarr[selectedcatarr?.length - 1]?.name){
              if(new_arr_obj?.type === "platform_code"){
                new_obj = new_arr_obj?.children?.find((item : any) => item?.type === selectedcatarr[count]?.type && item?.id == selectedcatarr[count]?.name);
              } else {
                new_obj = new_arr_obj?.children?.find((item : any) => item?.type === selectedcatarr[count]?.type && item?.name == selectedcatarr[count]?.name);
              }

              if(!new_obj){
                break;
              }

              count++;
              new_arr_obj = new_obj;
            }

          } 
          else if(journey === "journey_1"){

              while(new_arr_obj?.type !== selectedcatarr[selectedcatarr?.length - 1]?.type || new_arr_obj?.name != selectedcatarr[selectedcatarr?.length - 1]?.name || new_arr_obj?.id != selectedcatarr[selectedcatarr?.length - 1]?.name){  

                if(new_arr_obj?.type === "platform_code" || new_arr_obj?.type === "campaign_id"){
                  new_obj = new_arr_obj?.children?.find((item : any) => item?.type === selectedcatarr[count]?.type && item?.id == selectedcatarr[count]?.name);
                } else {
                  new_obj = new_arr_obj?.children?.find((item : any) => item?.type === selectedcatarr[count]?.type && item?.name == selectedcatarr[count]?.name);
                }

                if(!new_obj){
                  break;
                }

                count++;
                new_arr_obj = new_obj;
              }
          }

          new_arr_obj.children = [
            ...transformToObject(results, matricesData?.map(item => item?.backend_matrice_name), cols_hierarchy[cols_hierarchy?.findIndex((item) => selectedcatarr[selectedcatarr?.length - 1].type === item?.backend_name) + 1]?.backend_name)
          ];

          let sorted_data_arr = prev?.sort((a, b) => {
            const aIndex = cols_hierarchy.findIndex(item => item?.backend_name === a.type);
            const bIndex = cols_hierarchy.findIndex(item => item?.backend_name === b.type);
          
              if (aIndex !== bIndex) return aIndex - bIndex;
              return a.name?.localeCompare(b.name);
          });
          return sorted_data_arr;
        });

      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  }

  const onChangeSearchObjArr = (col_name: string) => {
    if(col_name === "adgroup_id"){
      setSearchFileArray(dropDownformatedData["adgroup_name"]);
      setSearchDataArr(dropDownformatedData["adgroup_name"]);
    }
    else if (col_name === "campaign_id"){
      setSearchFileArray(dropDownformatedData["campaign_name"]);
      setSearchDataArr(dropDownformatedData["campaign_name"]);
    }else {
    setSearchFileArray(dropDownformatedData[col_name]);
    setSearchDataArr(dropDownformatedData[col_name]);
    }
  }

  const onChangeSearchObjArr2 = (arr: any[]) => {
    let new_search_arr = arr?.map((item: any) => ({value: item?.name}))
    setSearchFileArray(new_search_arr);
    setSearchDataArr(new_search_arr);
  }
  const [searchBackendObj, setSearchBackendObj] = useState<SearchObjProps>({
    value: "",
    frontend_value_type: "",
    backend_value_type: ""
  });

  const onSearchValueChange = (Ipvalue: string) => {
    // setSearchObj((prev) => ({
    //   ...prev,
    //   value: Ipvalue,
    // }));

    setSearchObj((prev) => {
      let new_search_obj = {
        ...prev,
        value: Ipvalue,
      }
      setSearchBackendObj(new_search_obj);
      return new_search_obj;
    })
    const arr_name =
      searchobj?.backend_value_type?.toLowerCase() as keyof All_Sel_CategoriesProps;

    // setSel_Categories((prevState) => {
    //   let new_categories = {
    //   ...prevState,
    //   [arr_name]: [Ipvalue], // Ensure array exists
    // }
    // setSel_CategoriesDrawer(new_categories);
    // return new_categories;
  // });
    
    setSearchFocus(false);
  };

  const columnsApply = () => {
      if(matricesDataDrawer?.length > 0 && parametersDataDrawer?.length > 0){

        let parameterspositionChanged =  parametersDataDrawer?.filter((item: Parameter, index: number) => item.id !== (index + 1));
        let matricespositionChanged =  matricesDataDrawer?.filter((item: Matrice, index: number) => item.id !== (index + 1));

        if(parameterspositionChanged?.length > 0 || matricespositionChanged?.length > 0){
          setResetToggle(true);
        } else {
          setResetToggle(false);
        }

        setSel_Parameters(
          parametersDataDrawer
            .filter((m) => m?.toggle === true)
            .map((item) => item?.backend_parameter_name)
        );
        setDrawerToggle(false);

        setParametersData([...parametersDataDrawer]);
        setParameters_hierarchy(
            parametersDataDrawer?.map((m) => m?.backend_parameter_name)
          );
        // updateColumns([], "PARAMETER", parametersDataDrawer, [], true);

        setMatrices_hierarchy(
          matricesDataDrawer?.map((m) => m?.backend_matrice_name)
        );
        setMatricesData([...matricesDataDrawer]);
        let new_metrics_hierarchy = matricesDataDrawer?.map(item => item?.backend_matrice_name);
        setMatrices_hierarchy(new_metrics_hierarchy);
        // updateColumns([], "METRICE", [], matricesDataDrawer, true);

        // fetchTableData(productDetailsDrawer, matricesDataDrawer, new_product_details_hierarchy,  new_metrics_hierarchy);
        // fetchTotalData(productDetailsDrawer, matricesDataDrawer);
        setDrawerSubOption("");

      }
    
  }

  useEffect(()=>{
      if(resultData?.length > 0){
        fetchonClick(resultData[resultData?.length - 1], sel_categories, selectedarr, sort);
      }
  }, [selectedarr?.length, conditionsArr]);

  const [isDbDataChanges, setIsDbDataChanges] = useState<boolean>(false);

  return (
    <>
      <div
        className="flex flex-col absolute left-0 top-[72px]"
        style={{
          width: "100%",
          backgroundColor: "#FFF",
          height: "calc(100vh - 72px)",
        }}
      > 
        <div className="flex flex-col items-start gap-6 px-5 my-3" style={{
          height: "calc(100vh - 72px)",
          overflowY: 'auto',
          boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
        }}>
          <div
            className="flex flex-col h-fit items-start self-stretch rounded-[8px]"
            style={{
              backgroundColor: "#FFF",
              boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
              // maxHeight: "calc(100vh - 72px)",
              // overflowY: 'auto',
              position: 'relative'
            }}
          >
            <div className="flex flex-col items-start self-stretch sticky top-0 z-50">
              <div className="flex flex-col items-start gap-3 self-stretch sticky top-0 z-10">
                <div className="bg-[#FFF] py-3 px-3 flex w-full justify-between items-center sticky top-0 z-10" style={{
                  borderRadius: "8px 8px 0px 0px"
                }}>
                  <div className="flex items-center gap-2 relative">
                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setDrawerToggle(true);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M4.42312 9.01437C4.00215 9.01437 3.64583 8.86853 3.35416 8.57687C3.0625 8.2852 2.91666 7.92888 2.91666 7.50791V4.42312C2.91666 4.00214 3.0625 3.64582 3.35416 3.35416C3.64583 3.06249 4.00215 2.91666 4.42312 2.91666H15.5769C15.9978 2.91666 16.3542 3.06249 16.6458 3.35416C16.9375 3.64582 17.0833 4.00214 17.0833 4.42312V7.50791C17.0833 7.92888 16.9375 8.2852 16.6458 8.57687C16.3542 8.86853 15.9978 9.01437 15.5769 9.01437H4.42312ZM4.42312 7.76437H15.5769C15.6517 7.76437 15.7132 7.74034 15.7612 7.69228C15.8093 7.64423 15.8333 7.58277 15.8333 7.50791V4.42312C15.8333 4.34825 15.8093 4.2868 15.7612 4.23874C15.7132 4.19068 15.6517 4.16666 15.5769 4.16666H4.42312C4.34826 4.16666 4.2868 4.19068 4.23875 4.23874C4.19069 4.2868 4.16666 4.34825 4.16666 4.42312V7.50791C4.16666 7.58277 4.19069 7.64423 4.23875 7.69228C4.2868 7.74034 4.34826 7.76437 4.42312 7.76437ZM4.42312 17.0833C4.00215 17.0833 3.64583 16.9375 3.35416 16.6458C3.0625 16.3542 2.91666 15.9978 2.91666 15.5769V12.5C2.91666 12.079 3.0625 11.7227 3.35416 11.431C3.64583 11.1394 4.00215 10.9935 4.42312 10.9935H15.5769C15.9978 10.9935 16.3542 11.1394 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5769C17.0833 15.9978 16.9375 16.3542 16.6458 16.6458C16.3542 16.9375 15.9978 17.0833 15.5769 17.0833H4.42312ZM4.42312 15.8333H15.5769C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5769V12.5C15.8333 12.4251 15.8093 12.3637 15.7612 12.3156C15.7132 12.2676 15.6517 12.2435 15.5769 12.2435H4.42312C4.34826 12.2435 4.2868 12.2676 4.23875 12.3156C4.19069 12.3637 4.16666 12.4251 4.16666 12.5V15.5769C4.16666 15.6517 4.19069 15.7132 4.23875 15.7612C4.2868 15.8093 4.34826 15.8333 4.42312 15.8333Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Columns
                      </div>
                    </Button>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={onDrillUpHandler}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M15.6875 2.08073C16.3065 2.08073 16.8327 2.29809 17.266 2.73281C17.6993 3.16754 17.916 3.69538 17.916 4.31635C17.916 4.82066 17.7638 5.27073 17.4593 5.66656C17.1548 6.0624 16.7701 6.3249 16.3054 6.45406V8.37885C16.3054 8.99844 16.0864 9.52726 15.6483 9.96531C15.2103 10.4034 14.6814 10.6224 14.0618 10.6224H10.6243V13.5407C11.0891 13.6699 11.4737 13.9324 11.7781 14.3282C12.0827 14.7241 12.235 15.1741 12.235 15.6784C12.235 16.2994 12.0183 16.8273 11.585 17.262C11.1516 17.6967 10.6255 17.9141 10.0064 17.9141C9.38741 17.9141 8.85886 17.6967 8.42081 17.262C7.98275 16.8273 7.76372 16.2994 7.76372 15.6784C7.76372 15.1741 7.91602 14.7241 8.2206 14.3282C8.52504 13.9324 8.90963 13.6699 9.37435 13.5407L9.37435 10.6224L5.93685 10.6224C5.31727 10.6224 4.78845 10.4034 4.35039 9.96531C3.91234 9.52726 3.69331 8.99844 3.69331 8.37885V6.45406C3.22859 6.3249 2.84393 6.0624 2.53935 5.66656C2.23491 5.27073 2.08268 4.82066 2.08268 4.31635C2.08268 3.69538 2.30171 3.16754 2.73977 2.73281C3.17782 2.29809 3.70636 2.08073 4.32539 2.08073C4.94442 2.08073 5.4706 2.29809 5.90393 2.73281C6.33713 3.16754 6.55372 3.69538 6.55372 4.31635C6.55372 4.82066 6.4015 5.27073 6.09706 5.66656C5.79261 6.0624 5.40803 6.3249 4.94331 6.45406V8.37885C4.94331 8.66038 5.03852 8.89635 5.22893 9.08677C5.41935 9.27719 5.65532 9.3724 5.93685 9.3724H9.37435V6.45406C8.90963 6.3249 8.52504 6.0624 8.2206 5.66656C7.91602 5.27073 7.76372 4.82066 7.76372 4.31635C7.76372 3.69538 7.98275 3.16754 8.42081 2.73281C8.85886 2.29809 9.38741 2.08073 10.0064 2.08073C10.6255 2.08073 11.1516 2.29809 11.585 2.73281C12.0183 3.16754 12.235 3.69538 12.235 4.31635C12.235 4.82066 12.0827 5.27073 11.7781 5.66656C11.4737 6.0624 11.0891 6.3249 10.6243 6.45406L10.6243 9.3724L14.0618 9.3724C14.3434 9.3724 14.5793 9.27719 14.7698 9.08677C14.9602 8.89635 15.0554 8.66038 15.0554 8.37885V6.45406C14.5907 6.3249 14.2061 6.0624 13.9016 5.66656C13.5972 5.27073 13.445 4.82066 13.445 4.31635C13.445 3.69538 13.6639 3.16754 14.1018 2.73281C14.5399 2.29809 15.0684 2.08073 15.6875 2.08073ZM15.6843 3.33073C15.4082 3.33073 15.1743 3.42517 14.9825 3.61406C14.7907 3.80281 14.6948 4.03677 14.6948 4.31594C14.6948 4.5951 14.79 4.8292 14.9806 5.01823C15.171 5.2074 15.407 5.30198 15.6885 5.30198C15.962 5.30198 16.1932 5.20608 16.3823 5.01427C16.5714 4.82247 16.666 4.58983 16.666 4.31635C16.666 4.04288 16.5714 3.81024 16.3823 3.61844C16.1932 3.42663 15.9606 3.33073 15.6843 3.33073ZM10.0033 3.33073C9.7272 3.33073 9.49324 3.42517 9.30143 3.61406C9.10963 3.80281 9.01372 4.03677 9.01372 4.31594C9.01372 4.5951 9.10893 4.8292 9.29935 5.01823C9.48991 5.2074 9.72588 5.30198 10.0073 5.30198C10.2809 5.30198 10.5122 5.20608 10.7012 5.01427C10.8904 4.82247 10.985 4.58983 10.985 4.31635C10.985 4.04288 10.8904 3.81024 10.7012 3.61844C10.5122 3.42663 10.2796 3.33073 10.0033 3.33073ZM4.32227 3.33073C4.04615 3.33073 3.8122 3.42517 3.62039 3.61406C3.42859 3.80281 3.33268 4.03677 3.33268 4.31594C3.33268 4.5951 3.42789 4.8292 3.61831 5.01823C3.80873 5.2074 4.0447 5.30198 4.32623 5.30198C4.59984 5.30198 4.83115 5.20608 5.02018 5.01427C5.20935 4.82247 5.30393 4.58983 5.30393 4.31635C5.30393 4.04288 5.20935 3.81024 5.02018 3.61844C4.83115 3.42663 4.59852 3.33073 4.32227 3.33073ZM10.0033 14.6928C9.7272 14.6928 9.49324 14.7873 9.30143 14.9761C9.10963 15.1649 9.01372 15.3989 9.01372 15.678C9.01372 15.9572 9.10893 16.1913 9.29935 16.3803C9.48991 16.5695 9.72588 16.6641 10.0073 16.6641C10.2809 16.6641 10.5122 16.5682 10.7012 16.3764C10.8904 16.1845 10.985 15.9519 10.985 15.6784C10.985 15.405 10.8904 15.1723 10.7012 14.9805C10.5122 14.7887 10.2796 14.6928 10.0033 14.6928Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Drill Up
                      </div>
                    </Button>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={onDrillDownHandler}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M4.31253 17.9193C3.6935 17.9193 3.16732 17.7019 2.73398 17.2672C2.30065 16.8325 2.08398 16.3046 2.08398 15.6836C2.08398 15.1793 2.23621 14.7293 2.54065 14.3334C2.84523 13.9376 3.22989 13.6751 3.69461 13.5459V11.6211C3.69461 11.0016 3.91364 10.4727 4.35169 10.0347C4.78975 9.59663 5.31857 9.3776 5.93815 9.3776H9.37565V6.45927C8.91093 6.3301 8.52634 6.0676 8.2219 5.67177C7.91732 5.27594 7.76503 4.82587 7.76503 4.32156C7.76503 3.70059 7.98169 3.17274 8.41503 2.73802C8.84836 2.3033 9.37454 2.08594 9.99357 2.08594C10.6126 2.08594 11.1411 2.3033 11.5792 2.73802C12.0172 3.17274 12.2363 3.70059 12.2363 4.32156C12.2363 4.82587 12.084 5.27594 11.7794 5.67177C11.475 6.0676 11.0904 6.3301 10.6257 6.45927V9.3776H14.0632C14.6827 9.3776 15.2116 9.59663 15.6496 10.0347C16.0877 10.4727 16.3067 11.0016 16.3067 11.6211V13.5459C16.7714 13.6751 17.1561 13.9376 17.4607 14.3334C17.7651 14.7293 17.9173 15.1793 17.9173 15.6836C17.9173 16.3046 17.6983 16.8325 17.2602 17.2672C16.8222 17.7019 16.2936 17.9193 15.6746 17.9193C15.0556 17.9193 14.5294 17.7019 14.0961 17.2672C13.6629 16.8325 13.4463 16.3046 13.4463 15.6836C13.4463 15.1793 13.5985 14.7293 13.9029 14.3334C14.2074 13.9376 14.592 13.6751 15.0567 13.5459V11.6211C15.0567 11.3396 14.9615 11.1036 14.7711 10.9132C14.5807 10.7228 14.3447 10.6276 14.0632 10.6276H10.6257V13.5459C11.0904 13.6751 11.475 13.9376 11.7794 14.3334C12.084 14.7293 12.2363 15.1793 12.2363 15.6836C12.2363 16.3046 12.0172 16.8325 11.5792 17.2672C11.1411 17.7019 10.6126 17.9193 9.99357 17.9193C9.37454 17.9193 8.84836 17.7019 8.41503 17.2672C7.98169 16.8325 7.76503 16.3046 7.76503 15.6836C7.76503 15.1793 7.91732 14.7293 8.2219 14.3334C8.52634 13.9376 8.91093 13.6751 9.37565 13.5459V10.6276H5.93815C5.65662 10.6276 5.42065 10.7228 5.23023 10.9132C5.03982 11.1036 4.94461 11.3396 4.94461 11.6211V13.5459C5.40933 13.6751 5.79391 13.9376 6.09836 14.3334C6.4028 14.7293 6.55503 15.1793 6.55503 15.6836C6.55503 16.3046 6.33607 16.8325 5.89815 17.2672C5.46009 17.7019 4.93155 17.9193 4.31253 17.9193ZM4.31565 16.6693C4.59176 16.6693 4.82572 16.5748 5.01753 16.3859C5.20933 16.1972 5.30523 15.9632 5.30523 15.6841C5.30523 15.4049 5.20996 15.1708 5.0194 14.9818C4.82898 14.7926 4.59301 14.698 4.31148 14.698C4.03801 14.698 3.80676 14.7939 3.61773 14.9857C3.42857 15.1775 3.33398 15.4102 3.33398 15.6836C3.33398 15.9571 3.42857 16.1898 3.61773 16.3816C3.80676 16.5734 4.0394 16.6693 4.31565 16.6693ZM9.99669 16.6693C10.2728 16.6693 10.5068 16.5748 10.6986 16.3859C10.8904 16.1972 10.9863 15.9632 10.9863 15.6841C10.9863 15.4049 10.8911 15.1708 10.7007 14.9818C10.5101 14.7926 10.2741 14.698 9.99273 14.698C9.71912 14.698 9.4878 14.7939 9.29878 14.9857C9.10961 15.1775 9.01503 15.4102 9.01503 15.6836C9.01503 15.9571 9.10961 16.1898 9.29878 16.3816C9.4878 16.5734 9.72044 16.6693 9.99669 16.6693ZM15.6777 16.6693C15.9538 16.6693 16.1878 16.5748 16.3796 16.3859C16.5714 16.1972 16.6673 15.9632 16.6673 15.6841C16.6673 15.4049 16.5721 15.1708 16.3817 14.9818C16.1913 14.7926 15.9553 14.698 15.6738 14.698C15.4002 14.698 15.1688 14.7939 14.9798 14.9857C14.7907 15.1775 14.6961 15.4102 14.6961 15.6836C14.6961 15.9571 14.7907 16.1898 14.9798 16.3816C15.1688 16.5734 15.4015 16.6693 15.6777 16.6693ZM9.99669 5.30719C10.2728 5.30719 10.5068 5.21274 10.6986 5.02385C10.8904 4.8351 10.9863 4.60115 10.9863 4.32198C10.9863 4.04281 10.8911 3.80872 10.7007 3.61969C10.5101 3.43052 10.2741 3.33594 9.99273 3.33594C9.71912 3.33594 9.4878 3.43184 9.29878 3.62365C9.10961 3.81545 9.01503 4.04809 9.01503 4.32156C9.01503 4.59503 9.10961 4.82767 9.29878 5.01948C9.4878 5.21128 9.72044 5.30719 9.99669 5.30719Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Drill Down
                      </div>
                    </Button>

                    <Button
                      color="neutral"
                      sx={{
                        height: 32,
                        // width: 106,
                        backgroundColor: "#FFF",
                        color: "#1C1C1E",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        paddingX: "12px",
                        paddingY: 0,
                        gap: "8px",
                        borderRadius: "4px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      ref={menuButtonRef}
                      onClick={() => setSortByToggle(!sortByToggle)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M7.63562 10.5378C7.4584 10.5378 7.30993 10.4779 7.19021 10.358C7.07062 10.2383 7.01083 10.0899 7.01083 9.91281V4.47052L5.07979 6.40156C4.96701 6.51698 4.82611 6.57469 4.65708 6.57469C4.48806 6.57469 4.33889 6.5149 4.20958 6.39531C4.08028 6.2649 4.01562 6.1158 4.01562 5.94802C4.01562 5.78038 4.08028 5.63191 4.20958 5.5026L7.10062 2.61156C7.17854 2.53351 7.26111 2.47851 7.34833 2.44656C7.43569 2.41448 7.52924 2.39844 7.62896 2.39844C7.72868 2.39844 7.8234 2.41455 7.91312 2.44677C8.00285 2.47913 8.08618 2.53406 8.16312 2.61156L11.075 5.52344C11.1989 5.64733 11.26 5.79101 11.2583 5.95448C11.2568 6.11795 11.1914 6.2649 11.0621 6.39531C10.9328 6.5149 10.7864 6.57684 10.6229 6.58115C10.4594 6.58531 10.3131 6.52281 10.184 6.39365L8.26083 4.47052V9.92073C8.26083 10.0956 8.2009 10.2421 8.08104 10.3603C7.96118 10.4786 7.81271 10.5378 7.63562 10.5378ZM12.3702 17.5955C12.2705 17.5955 12.1758 17.5793 12.086 17.547C11.9963 17.5148 11.913 17.4599 11.836 17.3824L8.92417 14.4705C8.80028 14.3465 8.73917 14.2028 8.74083 14.0395C8.74236 13.876 8.80778 13.7291 8.93708 13.5986C9.06639 13.4791 9.21278 13.4171 9.37625 13.4128C9.53972 13.4085 9.68604 13.471 9.81521 13.6003L11.7383 15.5234V10.073C11.7383 9.8983 11.7983 9.75177 11.9181 9.63344C12.038 9.51524 12.1865 9.45615 12.3635 9.45615C12.5408 9.45615 12.6892 9.51601 12.809 9.63573C12.9285 9.75559 12.9883 9.90406 12.9883 10.0811V15.5234L14.9194 13.5922C15.0322 13.4769 15.1731 13.4193 15.3421 13.4193C15.5111 13.4193 15.6603 13.4791 15.7896 13.5986C15.9189 13.7291 15.9835 13.8781 15.9835 14.0457C15.9835 14.2135 15.9189 14.362 15.7896 14.4914L12.8985 17.3824C12.8206 17.4603 12.7381 17.5153 12.6508 17.5474C12.5635 17.5795 12.4699 17.5955 12.3702 17.5955Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          textAlign: "center",
                          lineHeight: "18px",
                          color: "#1C1C1E",
                        }}
                      >
                        Sort
                      </div>
                    </Button>
                    {sortByToggle && (
                      <div
                        className="absolute bg-slate-400 h-[224px] w-[240px] top-10 left-[336px] rounded-[8px] inline-flex py-2 flex-col justify-center items-start"
                        style={{
                          backgroundColor: "#FFF",
                          boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                          zIndex: 500,
                        }}
                        ref={menuRef}
                      >
                        {sortValues?.length > 0 &&
                          sortValues?.map((value) => (
                            <div
                              className="flex w-full h-[52px] p-4 justify-between items-center cursor-pointer"
                              key={value}
                              onClick={() => {
                                setSort((prev) => {
                                  let new_sort_obj = {
                                  ...prev,
                                  sort_by: value,
                                }
                                if(new_sort_obj?.direction !== "" && new_sort_obj?.metric !== "" && new_sort_obj?.sort_by !== ""){
                                  fetchonClick(resultData[resultData?.length - 1], sel_categories, selectedarr, new_sort_obj);
                                }
                                return new_sort_obj;
                              });


                                setSortByToggle(false);
                              }}
                            >
                              <div
                                style={{
                                  color: "var(--Text-Primary-Black, #1C1C1E)",
                                  fontFamily: "Inter",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight:
                                    sort?.sort_by === value ? 600 : 400,
                                  lineHeight: "18px",
                                }}
                              >
                                {`Sort By ${
                                  value === "current"
                                    ? "Current Value"
                                    : value === "previous"
                                    ? "Comparison Value"
                                    : value === "difference"
                                    ? "Difference Value"
                                    : "Difference Percentage"
                                }`}
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>

                  <div className="flex h-[32px] items-center gap-2">
                    <div
                      className="flex justify-between w-[200px] px-4 py-2 items-center gap-2 self-stretch rounded-[4px] h-fit relative"
                      style={{
                        border: "1px solid #EAEAED",
                      }}
                    >
                      <input
                        type="text"
                        name=""
                        className="w-full h-[16px]"
                        placeholder={searchobj?.frontend_value_type === "" ? "" : `Search by ${searchobj?.frontend_value_type}`}
                        value={searchobj?.value}
                        onChange={onSearchvalueInputChange}
                        style={{
                          fontSize: "12px",
                          fontWeight: searchobj?.value ? 500 : 400,
                          lineHeight: "18px",
                          outline: "none",
                        }}
                      />

                      {searchFocus && !searchobjToggle && (
                        <div
                          style={{
                            position: "absolute",
                            top: 37,
                            left: 0,
                            width: 200,
                            maxHeight: 242,
                            borderRadius: 8,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            borderBottom: `1px solid ${BLACK.B_10}`,
                            borderLeft: `1px solid ${BLACK.B_10}`,
                            borderRight: `1px solid ${BLACK.B_10}`,
                            backgroundColor: WHITE.W_100,
                            zIndex: 100,
                            boxShadow: "0px 4px 10px 4px rgba(28,28,30,0.05)",
                          }}
                        >
                          <div
                            style={{
                              width: 200,
                              flex: 1,
                              paddingTop: 8,
                              paddingBottom: 8,
                              maxHeight: 242,
                              overflow: "auto",
                            }}
                          >
                            {searchFileArray?.map((obj) => {
                              return (
                                <div
                                  key={obj?.value}
                                  onClick={() =>
                                    onSearchValueChange(obj?.value)
                                  }
                                  style={{
                                    display: "flex",
                                    padding: "16px",
                                    alignItems: "center",
                                    gap: "8px",
                                    alignSelf: "stretch",
                                    cursor: "pointer",
                                    width: 194,
                                  }}
                                >
                                  <div
                                    style={{
                                      color:
                                        "var(--Text-Primary-Black, #1C1C1E)",
                                      fontFamily: "Inter",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight:
                                        searchobj?.value === obj?.value
                                          ? 500
                                          : 400,
                                      lineHeight: "18px",
                                      width: "100%",
                                      textWrap: "wrap",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {obj?.value}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>

                    <Button
                      sx={{
                        backgroundColor: "#FFF",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        borderRadius: "4px",
                        paddingX: "12px",
                        paddingY: "0px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        className=""
                        style={{
                          color: "#1C1C1E",
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          lineHeight: "18px",
                        }}
                      >
                        View Graph
                      </div>
                      <img
                        src={GraphIcon}
                        alt="Graph Icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() => setDateToggle(true)}
                      />
                    </Button>

                    <Button
                      sx={{
                        backgroundColor: "#FFF",
                        ":hover": {
                          backgroundColor: "#FFF",
                        },
                        borderRadius: "6px",
                        paddingX: "6px",
                        paddingY: "0px",
                        border: `1px solid #EAEAED`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setExportToggle(true)}
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <ConditionCompCmp 
              local_Cond_name={local_Cond_name}
              setlocal_Cond_name={setlocal_Cond_name}
              setlocal_Cond_id={setlocal_Cond_id}

              conditionsArr={conditionsArr} 
              setConditionsArr={setConditionsArr}
              localconditions={localconditions}
              setLocalConditions={setLocalConditions}
              newconditionsArr={newconditionsArr}
              setNewConditionsArr={setNewConditionsArr}
              matricsArr={matricsArr}
              parameterArr={parameterArr}
              operationsArr={operationsArr}
              listarr={listarr}

              conditionToggle={conditionToggle}
              page_name="DRILL_THROUGH_COMPARISON"
              ClearAll={ClearAll}
              setConditionToggle={setConditionToggle}
              isDbDataChanges={isDbDataChanges}
              setIsDbDataChanges={setIsDbDataChanges}
              setSaveConditionToggle={setSaveConditionToggle}
              temp_list_name={temp_list_name}
              setTemp_List_name={setTemp_List_name}
              createConditionLists={createConditionLists}
              saveConditionToggle={saveConditionToggle}
              conditonsSave={conditonsSave}
              setConfirmConditionToggle={setConfirmConditionToggle}
              />

            <div className="flex flex-col items-start self-stretch" >
              <div className="h-[56px] flex items-center py-3 px-3 justify-end gap-4 self-stretch">
                <div
                  className="flex h-[32px] px-[4px] py-[2px] items-start rounded-[4px] "
                  style={{
                    backgroundColor: "#F9F9FB",
                  }}
                >
                  <div
                    style={{
                      backgroundColor:
                        valueFilter === "VALUE" ? "#FFF" : "#F9F9FB",
                      display: "flex",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      boxShadow:
                        valueFilter === "VALUE"
                          ? "0px 4px 16px 6px rgba(130, 130, 130, 0.05)"
                          : "none",
                    }}
                    onClick={() => setValueFilter("VALUE")}
                  >
                    <div
                      style={{
                        color:
                          valueFilter === "VALUE"
                            ? "#1565C0"
                            : "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: valueFilter === "VALUE" ? 600 : 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* Content goes here */}
                      Value
                    </div>
                  </div>

                  <div
                    style={{
                      backgroundColor:
                        valueFilter === "SHARE" ? "#FFF" : "#F9F9FB",
                      display: "flex",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      boxShadow:
                        valueFilter === "SHARE"
                          ? "0px 4px 16px 6px rgba(130, 130, 130, 0.05)"
                          : "none",
                    }}
                    onClick={() => setValueFilter("SHARE")}
                  >
                    <div
                      style={{
                        color:
                          valueFilter === "SHARE"
                            ? "#1565C0"
                            : "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: valueFilter === "SHARE" ? 600 : 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* Content goes here */}% Share
                    </div>
                  </div>

                  <div
                    style={{
                      backgroundColor:
                        valueFilter === "AVERAGE" ? "#FFF" : "#F9F9FB",
                      display: "flex",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      boxShadow:
                        valueFilter === "AVERAGE"
                          ? "0px 4px 16px 6px rgba(130, 130, 130, 0.05)"
                          : "none",
                    }}
                    onClick={() => setValueFilter("AVERAGE")}
                  >
                    <div
                      style={{
                        color:
                          valueFilter === "AVERAGE"
                            ? "#1565C0"
                            : "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: valueFilter === "AVERAGE" ? 600 : 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* Content goes here */}
                      Average
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                width: "calc(100vw - 40px)",
              }}
            >
              {loading ? (
                <div
                  className="flex justify-center items-center"
                  style={{
                    height: "calc(100vh - 258px)",
                    width: "calc(100vw - 40px)"
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <div
                  className=""
                  style={{
                    height: "calc(100vh - 160px)",
                    width: "calc(100vw - 40px)",
                    zIndex: 10
                  }}
                >
                  {resultData?.length > 0 && (
                    <DrillThroughTable 
                      data={resultData} 
                      cols_hierarchy = {cols_hierarchy}
                      columns = {matricesData?.filter(item => item?.toggle)?.map((item) => ({headerName: item?.matrice_name, field: item?.backend_matrice_name}))}
                      selectedarr={selectedarr}
                      setSelectedArr={setSelectedArr}
                      sel_categories={sel_categories}
                      setSel_Categories={setSel_Categories}
                      selPreviousArr={selPreviousArr}
                      fetchonClick={fetchonClick}
                      positive_values={positive_values}
                      negative_values={negative_values}
                      parameters_hierarchy={parameters_hierarchy}
                      sort={sort}
                      setSort={setSort}
                      searchobj={searchBackendObj}
                      setSearchObj={setSearchObj}
                      setSearchBackendObj={setSearchBackendObj}
                      onChangeSearchObjArr={onChangeSearchObjArr}
                      onChangeSearchObjArr2={onChangeSearchObjArr2}
                      sel_parameters={sel_parameters}
                      conditionsArr={conditionsArr}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Drawer
        key={"right"}
        anchor={"right"}
        open={drawerToggle}
        size="md"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "none", // Disable the blur effect
            },
          },
        }}
      >
        <div
          className="flex p-4 items-center justify-between gap-10"
          style={{
            height: 52,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
          }}
        >
          <div
          style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "18px",
          }}
          >
          Columns
          </div>
          <div className="flex justify-between items-center gap-2">
            <div
              className="w-fit cursor-pointer"
              onClick={() =>{
                setParametersDataDrawer([...parametersData]);
                setMatricesDataDrawer([...matricesData]);
                setDrawerToggle(false);
                setDrawerSubOption("");
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                  fill="#1C1C1C"
                />
              </svg>
            </div>
          </div>
        </div>
        <DialogContent sx={{ backgroundColor: WHITE.W_100 }}>
          <div className="flex h-full w-full p-4 flex-col items-start self-stretch">
            <div className="flex flex-col items-start gap-4 self-stretch">
              {/* Product Details */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "JOURNEY_DETAILS"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "JOURNEY_DETAILS") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("JOURNEY_DETAILS");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Journey Details
                    </div>
                    {drawerSubOption === "JOURNEY_DETAILS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "JOURNEY_DETAILS" && (
                  <div className="py-4 w-full flex flex-col gap-1">
                    {cols_hierarchy?.map((col, index) => (
                      <>
                      {selPreviousArr?.slice(0,-1)?.some(item => item?.type === col?.backend_name) ? (
                        <div className="flex px-4 items-start gap-[15px]">
                          <div className="flex flex-col items-center gap-1">
                              <div className="flex w-4 h-4 p-[1px] justify-center items-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path d="M14.6668 7.99996C14.6668 4.31806 11.6821 1.33329 8.00016 1.33329C4.31826 1.33329 1.3335 4.31806 1.3335 7.99996C1.3335 11.6819 4.31826 14.6666 8.00016 14.6666C11.6821 14.6666 14.6668 11.6819 14.6668 7.99996Z" fill="#B7B7B9" stroke="#B7B7B9" stroke-width="1.5"/>
                                  <path d="M5.3335 8.49998C5.3335 8.49998 6.40016 9.10833 6.9335 9.99998C6.9335 9.99998 8.5335 6.49998 10.6668 5.33331" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                              </div>
                              <div className="w-0 h-[50px] rounded-[2px]" style={{
                                  border: "2px solid #F2F2F5"
                              }}></div>
                          </div>
                          <div className="flex flex-col items-start gap-1">
                              <div
                              style={{
                                  color: "var(--Text-Primary-Disabled, #B7B7B9)",
                                  fontFamily: "Inter",
                                  fontSize: "10px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "10px",
                                  letterSpacing: "1.6px",
                                  textTransform: "uppercase",
                              }}
                              >
                              STEP {index < 9 ? `0${index+1}` : `${index+1}`}
                              </div>
                              <div
                              style={{
                                  color: "var(--Text-Primary-Disabled, #B7B7B9)",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "18px",
                              }}
                              >
                              {col?.frontend_name}
                              </div>
                          </div>
                        </div>
                        ) : selectedarr?.some(item => item?.type === col?.backend_name) ? (
                          <div className="flex px-4 items-start gap-[15px]">
                          <div className="flex flex-col items-center gap-1">
                              <div className="flex w-4 h-4 p-[1px] justify-center items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path d="M14.6668 8.00008C14.6668 4.31818 11.6821 1.33342 8.00016 1.33342C4.31826 1.33342 1.3335 4.31818 1.3335 8.00008C1.3335 11.682 4.31826 14.6667 8.00016 14.6667C11.6821 14.6667 14.6668 11.682 14.6668 8.00008Z" fill="#186846" stroke="#186846" stroke-width="1.5"/>
                                  <path d="M5.3335 8.50004C5.3335 8.50004 6.40016 9.10839 6.9335 10C6.9335 10 8.5335 6.50004 10.6668 5.33337" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                              <div className="w-0 h-[50px] rounded-[2px]" style={{
                                  border: "2px solid #186846"
                              }}></div>
                          </div>
                          <div className="flex flex-col items-start gap-1">
                              <div
                              style={{
                                  color: "var(--Text-Primary-Disabled, #97979A)",
                                  fontFamily: "Inter",
                                  fontSize: "10px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "10px",
                                  letterSpacing: "1.6px",
                                  textTransform: "uppercase",
                              }}
                              >
                              STEP {index < 9 ? `0${index+1}` : `${index+1}`}
                              </div>
                              <div
                              style={{
                                  color: "var(--Text-Primary-Disabled, #1C1C1E)",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "18px",
                              }}
                              >
                              {col?.frontend_name}
                              </div>
                          </div>
                        </div>
                        ) : (
                          <div className="flex px-4 items-start gap-[15px]">
                            <div className="flex flex-col items-center gap-1">
                                <div className="flex w-4 h-4 p-[1px] justify-center items-center">
                                  {cols_hierarchy[ cols_hierarchy?.findIndex(item => item?.backend_name === selectedarr[selectedarr?.length - 1]?.type ) + 1]?.backend_name === col?.backend_name ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M7.99984 11C8.83228 11 9.54039 10.7081 10.1242 10.1243C10.7079 9.54051 10.9998 8.8324 10.9998 7.99996C10.9998 7.16752 10.7079 6.4594 10.1242 5.87563C9.54039 5.29185 8.83228 4.99996 7.99984 4.99996C7.16739 4.99996 6.45928 5.29185 5.8755 5.87563C5.29173 6.4594 4.99984 7.16752 4.99984 7.99996C4.99984 8.8324 5.29173 9.54051 5.8755 10.1243C6.45928 10.7081 7.16739 11 7.99984 11ZM8.001 14.3333C7.125 14.3333 6.30162 14.1671 5.53084 13.8346C4.76006 13.5022 4.08962 13.051 3.5195 12.4811C2.94939 11.9112 2.498 11.2411 2.16534 10.4706C1.83278 9.70018 1.6665 8.87702 1.6665 8.00113C1.6665 7.12513 1.83273 6.30174 2.16517 5.53096C2.49762 4.76018 2.94878 4.08974 3.51867 3.51963C4.08856 2.94951 4.75873 2.49813 5.52917 2.16546C6.29962 1.8329 7.12278 1.66663 7.99867 1.66663C8.87467 1.66663 9.69806 1.83285 10.4688 2.16529C11.2396 2.49774 11.9101 2.9489 12.4802 3.51879C13.0503 4.08868 13.5017 4.75885 13.8343 5.52929C14.1669 6.29974 14.3332 7.1229 14.3332 7.99879C14.3332 8.87479 14.1669 9.69818 13.8345 10.469C13.5021 11.2397 13.0509 11.9102 12.481 12.4803C11.9111 13.0504 11.2409 13.5018 10.4705 13.8345C9.70006 14.167 8.87689 14.3333 8.001 14.3333ZM7.99984 13.3333C9.48873 13.3333 10.7498 12.8166 11.7832 11.7833C12.8165 10.75 13.3332 9.48885 13.3332 7.99996C13.3332 6.51107 12.8165 5.24996 11.7832 4.21663C10.7498 3.18329 9.48873 2.66663 7.99984 2.66663C6.51095 2.66663 5.24984 3.18329 4.2165 4.21663C3.18317 5.24996 2.6665 6.51107 2.6665 7.99996C2.6665 9.48885 3.18317 10.75 4.2165 11.7833C5.24984 12.8166 6.51095 13.3333 7.99984 13.3333Z" fill="#1565C0"/>
                                  </svg>
                                  ) :
                                  (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M8.001 14.3208C7.12663 14.3208 6.30493 14.1549 5.53579 13.8231C4.7664 13.4913 4.09729 13.041 3.52834 12.4723C2.95939 11.9036 2.50888 11.2347 2.17681 10.4657C1.84496 9.69686 1.679 8.87539 1.679 8.00113C1.679 7.12675 1.84491 6.30506 2.17665 5.53591C2.50849 4.76652 2.95879 4.09741 3.52751 3.52846C4.09624 2.95951 4.76507 2.509 5.53413 2.17694C6.30294 1.84508 7.12441 1.67913 7.99867 1.67913C8.87304 1.67913 9.69474 1.84503 10.4639 2.17677C11.2333 2.50862 11.9024 2.95891 12.4713 3.52763C13.0403 4.09636 13.4908 4.76519 13.8229 5.53425C14.1547 6.30306 14.3207 7.12453 14.3207 7.99879C14.3207 8.87317 14.1548 9.69486 13.823 10.464C13.4912 11.2334 13.0409 11.9025 12.4722 12.4715C11.9034 13.0404 11.2346 13.4909 10.4655 13.823C9.69674 14.1548 8.87527 14.3208 8.001 14.3208ZM7.99984 13.3458C9.49197 13.3458 10.7563 12.8279 11.792 11.7921C12.8277 10.7564 13.3457 9.49209 13.3457 7.99996C13.3457 6.50783 12.8277 5.24351 11.792 4.20779C10.7563 3.17206 9.49197 2.65413 7.99984 2.65413C6.5077 2.65413 5.24339 3.17206 4.20767 4.20779C3.17194 5.24351 2.654 6.50783 2.654 7.99996C2.654 9.49209 3.17194 10.7564 4.20767 11.7921C5.24339 12.8279 6.5077 13.3458 7.99984 13.3458Z" fill="#97979A" stroke="#EAEAED" stroke-width="0.025"/>
                                  </svg>)}
                                </div>
                                {index !== cols_hierarchy?.length - 1 && (<div className="w-0 h-[50px] rounded-[2px]" style={{
                                    border: "2px solid #EAEAED"
                                }}></div>)}
                            </div>
                            <div className="flex flex-col items-start gap-1">
                                <div
                                style={{
                                    color: "var(--Text-Primary-Disabled, #97979A)",
                                    fontFamily: "Inter",
                                    fontSize: "10px",
                                    fontStyle: "normal",
                                    fontWeight: 500,
                                    lineHeight: "10px",
                                    letterSpacing: "1.6px",
                                    textTransform: "uppercase",
                                }}
                                >
                                STEP {index < 9 ? `0${index+1}` : `${index+1}`}
                                </div>
                                <div
                                style={{
                                    color: "var(--Text-Primary-Disabled, #1C1C1E)",
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    fontWeight: cols_hierarchy[ cols_hierarchy?.findIndex(item => item?.backend_name === selectedarr[selectedarr?.length - 1]?.type ) + 1]?.backend_name === col?.backend_name ? 700 : 500,
                                    lineHeight: "18px",
                                }}
                                >
                                {col?.frontend_name}
                                </div>
                            </div>
                        </div>
                        )}
                      </>
                      
                    ))}
                    
                  </div>
                )}
              </div>

            <div className="py-2] w-full flex gap-2 items-center">
                <div className="w-[50%] h-0" style={{
                    border: "1px solid #EAEAED"
                }}></div>
                <div
                style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "22px",
                    textWrap: "nowrap"
                }}
                >
                Column Selection
                </div>
                <div className="w-[50%] h-0" style={{
                    border: "1px solid #EAEAED"
                }}></div>
            </div>

              {/* Parameters */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "PARAMETERS"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "PARAMETERS") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("PARAMETERS");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Parameters
                    </div>
                    {drawerSubOption === "PARAMETERS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "PARAMETERS" && (
                  <div className="flex flex-col items-start self-stretch">
                    {parametersDataDrawer.length > 0 &&
                      parametersDataDrawer.map((p: Parameter) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={p?.parameter_name}
                          draggable
                          onDragStart={() => parameterDragStarthandle(p)}
                          onDragOver={parameterDragOverhandle}
                          onDrop={() => parameterhandleDrop(p)}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: p?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {p?.parameter_name}
                            </div>
                          </div>
                          <Switch
                            checked={p?.toggle}
                            onChange={(event) =>
                              ParameterSwitchChangeHandler(p?.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>

              {/* Metrices */}
              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px] mb-4"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "METRICES"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "METRICES") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("METRICES");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Metrics
                    </div>
                    {drawerSubOption === "METRICES" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "METRICES" && (
                  <div className="flex flex-col items-start self-stretch">
                    {matricesDataDrawer.length > 0 &&
                      matricesDataDrawer?.map((m: Matrice) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={m?.matrice_name}
                          draggable
                          onDragStart={() => metriceDragStarthandle(m)}
                          onDragOver={metriceDragOverhandle}
                          onDrop={() => metricehandleDrop(m)}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: m?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {m?.matrice_name}
                            </div>
                          </div>
                          <Switch
                            checked={m?.toggle}
                            onChange={(event) =>
                              MatriceSwitchChangeHandler(m?.id)
                            }
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <div
          className="h-[68px] w-full p-4 flex gap-6 justify-center items-center"
          style={{
            borderTop: "1px solid #EAEAED",
            backgroundColor: WHITE.W_100,
          }}
        >
          <Button
            sx={{
              backgroundColor: "#FFF",
              ":hover": {
                backgroundColor: "#FFF",
              },
              borderRadius: "4px",
              paddingX: "6px",
              width: "50%",
              paddingY: "0px",
              border: `1px solid #EAEAED`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "inter",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
              color: resetToggle ? "#1C1C1E" : "#B7B7B9",
              '&.Mui-disabled': {
                                backgroundColor: 'white',  // Change this to the desired color
                                color: "#B7B7B9"
                              },
            }}
            onClick={onResetColumnsHandler}
            disabled={!resetToggle}
          >
            Reset Columns
          </Button>

          <Button
            onClick={columnsApply}
            sx={{
              height: "36px",
              width: "50%",
              backgroundColor: "#1565C0",
              color: "#FFF",
              borderRadius: "4px",
              padding: "0px 6px",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
            loading={loading}
          >
            Apply
          </Button>
        </div>
      </Drawer>

      {confirmConditionToggle && (
        <ConfirmConditionModal
          setConfirmConditionToggle={setConfirmConditionToggle}
          setCreateNewCond={setCreateNewCond}
          local_Cond_name={local_Cond_name}
          setlocal_Cond_name={setlocal_Cond_name}
          local_Cond_id={local_Cond_id}
          localConditionsArr={localconditions}
          newConditionsArr={newconditionsArr}
          fetchConditionsData={fetchConditionsData}
          ClearAll={ClearAll}
          setConditionsArr={setConditionsArr}
          setConditionToggle={setConditionToggle}
          isDbDataChanges={isDbDataChanges}
          setIsDbDataChanges={setIsDbDataChanges}
          page_name="DRILL_THROUGH_COMPARISON"
        />
      )}

      {createNewCond && (
        <CreateNewConditionModal
          setConfirmConditionToggle={setConfirmConditionToggle}
          localConditionsArr={localconditions}
          newConditionsArr={newconditionsArr}
          setCreateNewCond={setCreateNewCond}
          fetchConditionsData={fetchConditionsData}
          ClearAll={ClearAll}
          listarr={listarr}
          page_name="DRILL_THROUGH_COMPARISON"
        />
      )}
    </>
  );
};

export default Drill_Through_Page;